'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.randomString = randomString;
/**
 * @description Returns a random string with the given length.
 * @summary
 * The parameter `base` can be specified, if the base should not be 26
 * (for example, when generating random hex strings).
 *
 * @example <caption>get some kind of random string</caption>
 * randomString();
 *
 * @example <caption>get a random string that is exactly 6 characters long</caption>
 * randomString(6);
 *
 * @example <caption>generate random color</caption>
 * '#' + randomString(6, 16);
 *
 * @param {number} [length=8] - Length of the generated random string. Note, that this maxes out at about 50 characters
 * @param {number} [base=26] - The base used to convert the random number to a random string.
 * @returns {string}
 */
function randomString() {
    var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 8;
    var base = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 26;

    if (length <= 0) {
        return '';
    }

    var randomString = '';
    do {
        randomString += Math.random().toString(base).substr(2);
    } while (randomString.length < length);

    return randomString.substr(0, length);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nimius/string-utility/src/random-string.js
// module id = 66
// module chunks = 0 2